import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "question-complementary-info-editor-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_html_editor = _resolveComponent("quiz-html-editor");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_quiz_html_editor, {
    editorId: _ctx.editorId,
    "custom-editor-config": _ctx.editorConfig,
    "editor-title": _ctx.$t('chapter.question.complementaryInfo.title'),
    content: _ctx.realtimeComplementaryInfo,
    "display-close-btn": true,
    "close-btn-label": _ctx.$t('chapter.question.complementaryInfo.closeBtn'),
    onBlur: _ctx.onComplementaryInfoBlur,
    onCloseBtnClick: _ctx.onCloseBtnClick
  }, null, 8, ["editorId", "custom-editor-config", "editor-title", "content", "close-btn-label", "onBlur", "onCloseBtnClick"])]);
}